import { render } from "./CategoryCountryEditModalPopup.vue?vue&type=template&id=65ab8932&scoped=true"
import script from "./CategoryCountryEditModalPopup.vue?vue&type=script&lang=js"
export * from "./CategoryCountryEditModalPopup.vue?vue&type=script&lang=js"

import "./CategoryCountryEditModalPopup.vue?vue&type=style&index=0&id=65ab8932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ab8932"]])

export default __exports__